import { FC } from "react";
import styles from "./styles.module.scss";
import PlaceholderAvatar from "../../assets/images/avatar.png";

import { format } from "date-fns";
import { type FeedbackItem as FeedbackItemType } from "../../services/feedback.service";
import FeedbackType from "../FeedbackType";

interface Props {
  item: FeedbackItemType;
}

const FeedbackItem: FC<Props> = ({ item }): JSX.Element => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.avatarWrapper}>
        <img
          src={item?.image ? item?.image : PlaceholderAvatar}
          alt="avatar"
          className={styles.avatar}
        />
        <div>
          <p className={styles.name}>{`${item?.firstName}`}</p>
          <p className={styles.email}>{`${item?.email}`}</p>
        </div>
      </div>
      <div className={styles.typeWrapper}>
        <FeedbackType type={item.area} />
      </div>
      <div className={styles.feedbackWrapper}>
        {item.feedback.map((feed) => (
          <>
            {feed.title && <p className={styles.feedbackTitle}>{feed.title}</p>}
            {feed.text && <p className={styles.subtitle}>{feed.text}</p>}
          </>
        ))}
      </div>
      <div className={styles.reportedWrapper}>{item.appVersion}</div>
      <div className={styles.dateWrapper}>
        <p>
          {item?.createdAt &&
            format(new Date(item?.createdAt || ""), "LLL d, yyyy hh:mm a")}
        </p>
      </div>
    </div>
  );
};

export default FeedbackItem;
